import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {MaintenanceStatusService} from 'src/app/infrastructure/service/maintenance-status.service';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  constructor(private maintenanceService: MaintenanceStatusService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/health')) {
      return next.handle(req);
    }

    const isUnderMaintenance = this.maintenanceService.isUnderMaintenanceSync();

    if (isUnderMaintenance) {
      const error = new HttpErrorResponse({
        error: 'Service under maintenance',
        status: 503,
        statusText: 'Service Unavailable',
        url: req.url
      });
      return throwError(() => error);
    }

    return next.handle(req);
  }
}
